import { faThumbsDown, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import { Col, Row, Card, Breadcrumb } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { useState } from 'react';
import Image from "../../../assets/user/images/adsHome/image.png";

const PageTopicIndex = () => {
    const { topicSlug } = useParams();
    const [topicSlugCurrent, setTopicSlugCurrent] = useState('');
    const [posts, setPosts] = useState([]);
    const [topic, setTopic] = useState([]);

    useEffect(() => {
        if (topicSlug !== topicSlugCurrent) {
            document.title = `Kafood | Chủ đề`;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            getPostAll();
        }
    }, []);

    const getPostAll = async () => {
        await axios.get(`/getPostsByTopics/${topicSlug}`)
            .then((res) => {
                if (res.data.errCode === 0) {
                    setPosts(res.data.posts[0].posts);
                    setTopic(res.data.posts[0]);
                    setTopicSlugCurrent(topicSlug);
                    document.title = `Kafood | ${res.data.posts[0].nameVi}`;
                } 
            })
            .catch(() => {});
    }

    const viewPosts = () => {
        let output = [];

        if (posts.length > 0) {
            for (let i = 0; i < posts.length; i++) {
                output[i] = (<Col md={i * 2 / 3 % 3 === 0 ? 6 : 3} key={`postItem${posts[i].id}`}>
                    <Card >
                        <Card.Img variant="top" src={posts[i].image} />

                        <Card.Body>
                            <Card.Title>
                                <a href={`/bai-viet/${posts[i].slug}`}>
                                    {posts[i].titleVi}
                                </a>
                            </Card.Title>
                            <Card.Text>
                                {posts[i].descVi}
                            </Card.Text>

                            <div className='cart-reviews'>
                                <Card.Link href="#">
                                    <FontAwesomeIcon icon={faThumbsUp} />
                                </Card.Link>
                                <Card.Link href="#">
                                    <FontAwesomeIcon icon={faThumbsDown} />
                                </Card.Link>
                            </div>
                        </Card.Body>
                    </Card>
                </Col >);
            }
            output?.push(
                <Col md={3} key={`postItem}`}>
                    <Card >
                        <Card.Img variant="top" src={Image} />

                        <Card.Body>
                            <Card.Title>
                                <a href={`/tai-sao-truong-mam-non-can-phai-su-dung-phan-mem-kafood`}>
                                TẠI SAO TRƯỜNG MẦM NON CẦN PHẢI SỬ DỤNG PHẦN MỀM KAFOOD?
                                </a>
                            </Card.Title>

                            <Card.Text>
                            TẠI SAO TRƯỜNG MẦM NON CẦN PHẢI SỬ DỤNG PHẦN MỀM KAFOOD?
                            </Card.Text>

                            <div className='cart-reviews'>
                                <Card.Link href="#">
                                    <FontAwesomeIcon icon={faThumbsUp} />
                                </Card.Link>
                                <Card.Link href="#">
                                    <FontAwesomeIcon icon={faThumbsDown} />
                                </Card.Link>
                            </div>
                        </Card.Body>
                    </Card>
                </Col >
            )

        } else {
            output = <h3>Hiện tại chưa có bài viết!</h3>;
        }

        return output;
    }

    return (
        <div className='detail_bg' id="page_blog">
            <div className='text_title'>
                <h1>{topic.nameVi}</h1>
            </div>
            <div className="container pt-3 ps-4 bg-light">
                <Breadcrumb >
                    <Breadcrumb.Item as={Link} to="/">
                        Trang chủ
                    </Breadcrumb.Item>
                    <Breadcrumb.Item as={Link} to="/goc-chia-se">
                        Góc chia sẻ
                    </Breadcrumb.Item>
                    <Breadcrumb.Item as={Link} to={`/chu-de/${topic.slug}`}>
                        {topic.nameVi}
                    </Breadcrumb.Item>
                </Breadcrumb>
            </div>

            <div className="container p-lg-4 pb-md-0 bg-light mb-4">
                <Row >
                    {viewPosts()}
                </Row>
            </div>
        </div >
    )
}

export default PageTopicIndex;